import { render, staticRenderFns } from "./FactFind.vue?vue&type=template&id=64cd1564&scoped=true"
import script from "./FactFind.vue?vue&type=script&lang=js"
export * from "./FactFind.vue?vue&type=script&lang=js"
import style0 from "./FactFind.vue?vue&type=style&index=0&id=64cd1564&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cd1564",
  null
  
)

export default component.exports